import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0 },
};

export function Container({ children, className = "" }) {
  return (
    <div className={`max-w-7xl mx-auto px-6 lg:px-8 ${className}`}>{children}</div>
  );
}

export function Section({ children, className = "", id }) {
  return (
    <section id={id} className={`py-20 md:py-28 lg:py-32 ${className}`}>
      <Container>{children}</Container>
    </section>
  );
}

export function Eyebrow({ children }) {
  return (
    <span className="inline-block text-xs uppercase tracking-[0.18em] font-semibold text-[#0262B4] mb-4">
      {children}
    </span>
  );
}

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function CTAButton({ to, children, variant = "primary", href, testId, className = "", onClick }) {
  const base =
    "inline-flex items-center justify-center gap-2 px-7 py-3.5 text-base font-semibold rounded-full transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-[#0262B4] focus:ring-offset-2";
  const styles = {
    primary:
      "ct-grad-navy-btn text-white hover:-translate-y-0.5 shadow-[0_8px_24px_rgb(2_98_180/0.28)]",
    ghost:
      "bg-transparent text-[#1E1E24] border border-[#1E1E24]/15 hover:border-[#0262B4] hover:text-[#0262B4]",
    light:
      "bg-white text-[#1E1E24] hover:bg-slate-100 hover:-translate-y-0.5",
    outlineLight:
      "bg-transparent text-white border border-white/30 hover:border-white hover:bg-white/10",
  };
  const cls = `${base} ${styles[variant]} ${className}`;
  if (href) {
    return (
      <a href={href} data-testid={testId} className={cls}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testId} className={cls} onClick={onClick}>
      {children}
    </Link>
  );
}
